import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'building_guid': 'String!',
	'lunch_option_guid': '[String]!',
};

export default gql(`
	mutation building_to_lunch_options( ${ HelperGraphql.createFields( fields ) } ) {
	    building_to_lunch_options( ${ HelperGraphql.createVariables( fields ) } ) {
	        building {
	            guid
	        }
	        
	        lunch_option {
	            guid
	        }
	    }
	}
`);

